import React from 'react'
import classNames from 'classnames'
import { Link } from 'react-router-dom'

import Icon from '../Icon'

import Loading from '../Loading'

import styles from './Button.module.css'

export default function Button(props) {
  let {
    className,
    to,
    target,
    icon,
    text,
    xs,
    small,
    large,
    color,
    disabled,
    loading,
    component,
    children,
    loadingText,
    ...otherProps
  } = props

  if (loading) {
    icon = 'placeholder'
  }

  disabled = disabled || loading

  let ButtonComponent = to ? Link : 'button'

  if (to && target === '_blank') {
    ButtonComponent = 'a'

    otherProps.href = to
    otherProps.target = target
  }

  if (component) {
    ButtonComponent = component
  }

  children = (loading && loadingText) || children

  return (
    <ButtonComponent
      {...otherProps}
      to={to}
      className={classNames(styles.button, className, {
        [styles.text]: text,
        [styles.xs]: xs,
        [styles.small]: small,
        [styles.large]: large,
        [styles.disabled]: disabled,
        [styles.loading]: loading,
        [styles[`color-${color}`]]: color,
      })}
    >
      {icon ? <Icon icon={icon} className={styles.icon} /> : null}
      {children}
      {loading ? (
        <div className={styles.loader}>
          <Loading small />
        </div>
      ) : null}
    </ButtonComponent>
  )
}
